import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIdenticon1 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "No avatar",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4879",
				x: .5,
				y: .5,
				width: 5,
				height: 5,
				stroke: "currentColor",
				strokeOpacity: .5
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4883",
				x: 1,
				y: 9,
				width: 4,
				height: 4,
				stroke: "currentColor",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4887",
				x: .5,
				y: 16.5,
				width: 5,
				height: 5,
				stroke: "currentColor",
				strokeOpacity: .5
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4891",
				x: .5,
				y: 24.5,
				width: 5,
				height: 5,
				stroke: "currentColor",
				strokeOpacity: .5
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4880",
				x: 9,
				y: 1,
				width: 4,
				height: 4,
				stroke: "currentColor",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4884",
				x: 9,
				y: 9,
				width: 4,
				height: 4,
				stroke: "currentColor",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4888",
				x: 9,
				y: 17,
				width: 4,
				height: 4,
				stroke: "currentColor",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4892",
				x: 8.5,
				y: 24.5,
				width: 5,
				height: 5,
				stroke: "currentColor",
				strokeOpacity: .5
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4881",
				x: 16.5,
				y: .5,
				width: 5,
				height: 5,
				stroke: "currentColor",
				strokeOpacity: .5
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4885",
				x: 17,
				y: 9,
				width: 4,
				height: 4,
				stroke: "currentColor",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4889",
				x: 17,
				y: 17,
				width: 4,
				height: 4,
				stroke: "currentColor",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4893",
				x: 16.5,
				y: 24.5,
				width: 5,
				height: 5,
				stroke: "currentColor",
				strokeOpacity: .5
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4882",
				x: 24.5,
				y: .5,
				width: 5,
				height: 5,
				stroke: "currentColor",
				strokeOpacity: .5
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4886",
				x: 24.5,
				y: 8.5,
				width: 5,
				height: 5,
				stroke: "currentColor",
				strokeOpacity: .5
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4890",
				x: 25,
				y: 17,
				width: 4,
				height: 4,
				stroke: "currentColor",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 4894",
				x: 25,
				y: 25,
				width: 4,
				height: 4,
				stroke: "currentColor",
				strokeWidth: 2
			})
		]
	})
});
export { SvgIdenticon1 as ReactComponent };
